
import { lazy, Suspense, useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";

const Home = lazy(() => import("./routes/Home"));
const SeeProject = lazy(() => import("./routes/SeeProject"));
const Testimony = lazy(() => import("./routes/Testimony"));
const OnlineTeaching = lazy(() => import("./routes/OnlineTeaching"));
const Contact = lazy(() => import("./routes/Contact"));
const Tabung = lazy(() => import("./routes/tabung"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Suspense
        fallback={
          <main className="route-loading" role="status" aria-live="polite">
            Loading page…
          </main>
        }
      >
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/seeproject">
            <SeeProject />
          </Route>
          <Route path="/testimony">
            <Testimony />
          </Route>
          <Route path="/online">
            <OnlineTeaching />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/tabung">
            <Tabung />
          </Route>
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
